import React, {
  useImperativeHandle,
  useState,
  forwardRef,
  useEffect,
  useRef,
} from 'react'
import PrimeModal from '@/components/primeModal'
import { Form, Select, Input, App, Radio } from 'antd'
import { useTranslation } from 'react-i18next'
import { queryProject, exportProject } from '@/api/export'

import { download } from '@/utils'
const { TextArea } = Input

const ExportDict = (props: any, ref: any) => {
  const { t } = useTranslation()
  const { message } = App.useApp()
  const [loading, setLoading] = useState(false)
  const [visible, setVisible] = useState(false)
  const [projects, setProjects] = useState([])
  const excelNameRef = useRef(null)
  const [form] = Form.useForm()

  const close = () => {
    setVisible(false)
    form.resetFields()
  }

  useImperativeHandle(ref, () => ({
    open: (record: any) => {
      form.setFieldsValue(record)
      excelNameRef.current = record.excelName
      setVisible(true)
    },
  }))
  const onFinish = async (values: any) => {
    setLoading(true)
    try {
      const res: any = await exportProject(values)
      download(res, 'application/vnd.ms-excel', `${values.excelName}.xlsx`)
      message.success(t('ikg.success', { action: t('ikg.export') }))
      close()
      setLoading(false)
    } catch (error) {
      close()
      setLoading(false)
    }
  }

  const fetchProjects = async () => {
    const res = await queryProject({
      type: 1,
    })
    setProjects(res as any)
  }

  useEffect(() => {
    if (!visible) return
    fetchProjects()
  }, [visible])
  return (
    <PrimeModal
      open={visible}
      title={t('dict.exportPkg')}
      onCancel={close}
      onOk={() => {
        form.submit()
      }}
      okButtonProps={{
        loading,
      }}
      cancelButtonProps={{
        disabled: loading,
      }}
    >
      <Form
        form={form}
        onFinish={onFinish}
        layout="vertical"
        autoComplete="off"
        initialValues={{
          type: 1,
        }}
      >
        <Form.Item
          label={t('dict.pkgName')}
          name="excelName"
          rules={[
            {
              required: true,
              message: t('ikg.input', { name: t('dict.pkgName') }),
            },
          ]}
          extra={t('dict.pkgNameExtra')}
        >
          <Input
            placeholder={t('ikg.input', { name: t('dict.pkgName') })}
            disabled
          />
        </Form.Item>
        <Form.Item
          label={t('dict.exportMethod')}
          rules={[
            {
              required: true,
              message: t('ikg.select', { name: t('dict.exportMethod') }),
            },
          ]}
          name="type"
        >
          <Radio.Group>
            <Radio value={1}>{t('dict.onlyItemExport')}</Radio>
            <Radio value={2}>{t('dict.dirAndItemExport')}</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label={t('dict.project')}
          name="projectCode"
          rules={[
            {
              required: true,
              message: t('ikg.select', { name: t('dict.project') }),
            },
          ]}
        >
          <Select
            placeholder={t('ikg.select', { name: t('dict.project') })}
            options={projects}
            fieldNames={{
              label: 'projectName',
              value: 'projectCode',
            }}
            onChange={(val: string, option: any) => {
              form.setFieldValue(
                'excelName',
                `${option.projectName}_${excelNameRef.current}`
              )
            }}
          />
        </Form.Item>
        <Form.Item label={t('dict.desc')} name="remark">
          <TextArea rows={4} maxLength={300} showCount />
        </Form.Item>
        <Form.Item hidden name="id">
          <Input />
        </Form.Item>
      </Form>
    </PrimeModal>
  )
}

export default forwardRef(ExportDict)
